/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.userprogress.bff.rpc.UserProgressBFFChirpService
 */

export const LessonProgressResponseTypename = 'com.hubspot.userprogress.bff.rpc.models.LessonProgressResponse';
export const PlaylistProgressResponseTypename = 'com.hubspot.userprogress.bff.rpc.models.PlaylistProgressResponse';
export const ShortProgressResponseTypename = 'com.hubspot.userprogress.bff.rpc.models.ShortProgressResponse';
export const TrackProgressResponseTypename = 'com.hubspot.userprogress.bff.rpc.models.TrackProgressResponse';
export const getUserProgressRpc = {
  serviceName: 'com.hubspot.userprogress.bff.rpc.UserProgressBFFChirpService',
  rpcName: 'getUserProgress',
  auth: 'app',
  fingerprint: 'EyWYBYoafJgHQ3vJo70tnq4AvDvBA3a6',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};